/** Chaves de persistência local — não alterar valores (sessões existentes). */

export const STORAGE_KEYS = {
  token: 'atlas_token',
  user: 'atlas_user',
  demoMode: 'atlas_demo_mode',
  auditFlows: 'atlasregistry.audit.flows.v1',
  registryAssistSync: 'atlasregistry.registry-assist.sync.v1',
  /** Legado — migrado para registryAssistSync. */
  integratedDemoSync: 'atlasregistry.integrated-demo.sync.v1',
  assistDemoSyncLegacy: 'atlasregistry.assist.demo.sync.v1'
} as const;

/** Token local de demonstração — nunca é JWT válido e não deve ir para a API. */
export const DEMO_SESSION_TOKEN = 'atlas-demo-local-session';
